// extracted by mini-css-extract-plugin
module.exports = {"root":"root--WNgqx","list":"list--rdS-J","item":"item--kVUZY","pagination":"pagination--0Q1Nd"};